import { ɵɵdefinePipe, ɵsetClassMetadata, Pipe, EventEmitter, ɵɵdirectiveInject, ElementRef, ɵɵdefineDirective, ɵɵlistener, Directive, Input, Output, HostListener, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

class ArraySortPipe {
    transform(array, args) {
        if (array == null) {
            return array;
        }
        array.sort(function (a, b) {
            if (a[args.property] < b[args.property]) {
                return -1 * args.direction;
            }
            else if (a[args.property] > b[args.property]) {
                return 1 * args.direction;
            }
            else {
                return 0;
            }
        });
        return array;
    }
}
ArraySortPipe.ɵfac = function ArraySortPipe_Factory(t) { return new (t || ArraySortPipe)(); };
ArraySortPipe.ɵpipe = ɵɵdefinePipe({ name: "sortbypipe", type: ArraySortPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ArraySortPipe, [{
        type: Pipe,
        args: [{ name: 'sortbypipe' }]
    }], null, null); })();

class PDatePipe {
    transform(date, args) {
        if (date == null) {
            return "";
        }
        //let d = new Date(date)
        console.log(date);
        return moment(date).local().format('DD-MM-YYYY HH:mm');
    }
}
PDatePipe.ɵfac = function PDatePipe_Factory(t) { return new (t || PDatePipe)(); };
PDatePipe.ɵpipe = ɵɵdefinePipe({ name: "pdate", type: PDatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PDatePipe, [{
        type: Pipe,
        args: [{
                name: 'pdate'
            }]
    }], null, null); })();

class ListSortEntityPipe {
    transform(date, args) {
        let d = new Date(date);
        return d;
    }
}
ListSortEntityPipe.ɵfac = function ListSortEntityPipe_Factory(t) { return new (t || ListSortEntityPipe)(); };
ListSortEntityPipe.ɵpipe = ɵɵdefinePipe({ name: "listsortentity", type: ListSortEntityPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ListSortEntityPipe, [{
        type: Pipe,
        args: [{
                name: 'listsortentity'
            }]
    }], null, null); })();

class SortIconPipe {
    transform(column, args) {
        if (column != args.sort_column) {
            return 'fas fa-sort';
        }
        else if (column == args.sort_column && args.sort_isDesc) {
            return 'fas fa-sort-up';
        }
        else if (column == args.sort_column && !args.sort_isDesc) {
            return 'fas fa-sort-down';
        }
        return '';
    }
}
SortIconPipe.ɵfac = function SortIconPipe_Factory(t) { return new (t || SortIconPipe)(); };
SortIconPipe.ɵpipe = ɵɵdefinePipe({ name: "sortico", type: SortIconPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SortIconPipe, [{
        type: Pipe,
        args: [{
                name: 'sortico'
            }]
    }], null, null); })();

class NumberToPipe {
    transform(column, compareto, defaultval) {
        // argsToCompare: any, defaultval:string
        const st = column;
        if (st === compareto) {
            return defaultval;
        }
        else {
            return column;
        }
    }
}
NumberToPipe.ɵfac = function NumberToPipe_Factory(t) { return new (t || NumberToPipe)(); };
NumberToPipe.ɵpipe = ɵɵdefinePipe({ name: "numbertopipe", type: NumberToPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NumberToPipe, [{
        type: Pipe,
        args: [{
                name: 'numbertopipe'
            }]
    }], null, null); })();

class FrVsiblePipe {
    transform(column, args) {
        const st = column;
        if (st === true) {
            return "fr-status-visible";
        }
        else if (st === false) {
            return "fr-status-hidden";
        }
        else {
            return "";
        }
    }
}
FrVsiblePipe.ɵfac = function FrVsiblePipe_Factory(t) { return new (t || FrVsiblePipe)(); };
FrVsiblePipe.ɵpipe = ɵɵdefinePipe({ name: "frvisiblepipe", type: FrVsiblePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrVsiblePipe, [{
        type: Pipe,
        args: [{
                name: 'frvisiblepipe'
            }]
    }], null, null); })();

class FrFileDropDirective {
    constructor(element) {
        this.fileOver = new EventEmitter();
        this.onFileDrop = new EventEmitter();
        this.hasBaseDropZoneOver = false;
        this.element = element;
    }
    getFilters() {
        return {};
    }
    onDrop(event) {
        let transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        let filters = this.getFilters();
        this._preventAndStop(event);
        if (this.queue) {
            this.queue.push(transfer.files);
        }
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }
    onDragOver(event) {
        let transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    }
    onDragLeave(event) {
        if (event.currentTarget === this.element[0]) {
            return;
        }
        this._preventAndStop(event);
        this.fileOver.emit(false);
    }
    _getTransfer(event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }
    _preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    _haveFiles(types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        else {
            return false;
        }
    }
}
FrFileDropDirective.ɵfac = function FrFileDropDirective_Factory(t) { return new (t || FrFileDropDirective)(ɵɵdirectiveInject(ElementRef)); };
FrFileDropDirective.ɵdir = ɵɵdefineDirective({ type: FrFileDropDirective, selectors: [["", "appFrFileDrop", ""]], hostBindings: function FrFileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("drop", function FrFileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function FrFileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function FrFileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
    } }, inputs: { queue: "queue" }, outputs: { fileOver: "fileOver", onFileDrop: "onFileDrop" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FrFileDropDirective, [{
        type: Directive,
        args: [{ selector: '[appFrFileDrop]' }]
    }], function () { return [{ type: ElementRef }]; }, { queue: [{
            type: Input
        }], fileOver: [{
            type: Output
        }], onFileDrop: [{
            type: Output
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }] }); })();

class FileSizePipe {
    transform(bytes) {
        const kB = 1024;
        const p = 1;
        if (bytes >= Math.pow(kB, 4)) {
            return (bytes / Math.pow(kB, 4)).toFixed(p) + ' TB';
        }
        if (bytes >= 100 * Math.pow(kB, 3)) {
            return (bytes / Math.pow(kB, 3)).toFixed(0) + ' GB';
        }
        if (bytes >= 10 * Math.pow(kB, 3)) {
            return (bytes / Math.pow(kB, 3)).toFixed(1) + ' GB';
        }
        if (bytes >= Math.pow(kB, 3)) {
            return (bytes / Math.pow(kB, 3)).toFixed(2) + ' GB';
        }
        if (bytes >= 100 * Math.pow(kB, 2)) {
            return (bytes / Math.pow(kB, 2)).toFixed(0) + ' MB';
        }
        if (bytes >= 10 * Math.pow(kB, 2)) {
            return (bytes / Math.pow(kB, 2)).toFixed(1) + ' MB';
        }
        if (bytes >= Math.pow(kB, 2)) {
            return (bytes / Math.pow(kB, 2)).toFixed(2) + ' MB';
        }
        if (bytes >= 100 * kB) {
            return (bytes / kB).toFixed(0) + ' kB';
        }
        if (bytes >= 10 * kB) {
            return (bytes / kB).toFixed(1) + ' kB';
        }
        if (bytes >= kB) {
            return (bytes / kB).toFixed(2) + ' kB';
        }
        return bytes + ' B';
    }
}
FileSizePipe.ɵfac = function FileSizePipe_Factory(t) { return new (t || FileSizePipe)(); };
FileSizePipe.ɵpipe = ɵɵdefinePipe({ name: "filesize", type: FileSizePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileSizePipe, [{
        type: Pipe,
        args: [{ name: 'filesize' }]
    }], null, null); })();

class DurationPipe {
    transform(msec) {
        const m = 60;
        const h = 60 * m;
        const d = 24 * h;
        const totalSec = Math.floor(msec / 1000);
        const days = Math.floor(totalSec / d);
        const hours = Math.floor(totalSec % d / h);
        const minutes = Math.floor(totalSec % h / m);
        const seconds = totalSec % m;
        let hoursStr = (hours < 10 ? '0' : '') + hours + ':';
        hoursStr = hours > 0 ? hoursStr : '';
        const durationStr = (days > 0 ? days + 'd + ' : '')
            + hoursStr
            + (minutes < 10 ? '0' : '') + minutes + ':'
            + (seconds < 10 ? '0' : '') + seconds;
        // console.log('DurationPipe: ' + durationStr);
        return durationStr;
    }
}
DurationPipe.ɵfac = function DurationPipe_Factory(t) { return new (t || DurationPipe)(); };
DurationPipe.ɵpipe = ɵɵdefinePipe({ name: "duration", type: DurationPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DurationPipe, [{
        type: Pipe,
        args: [{ name: 'duration' }]
    }], null, null); })();

class FileUploadRatePipe {
    transform(kbps) {
        const kB = 1024;
        const p = 1;
        if (kbps > Math.pow(kB, 2)) {
            return (kbps / Math.pow(kB, 2)).toFixed(p) + ' Gbps';
        }
        if (kbps > kB) {
            return (kbps / kB).toFixed(p) + ' Mbps';
        }
        return kbps + ' kbps';
    }
}
FileUploadRatePipe.ɵfac = function FileUploadRatePipe_Factory(t) { return new (t || FileUploadRatePipe)(); };
FileUploadRatePipe.ɵpipe = ɵɵdefinePipe({ name: "fileuploadrate", type: FileUploadRatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileUploadRatePipe, [{
        type: Pipe,
        args: [{ name: 'fileuploadrate' }]
    }], null, null); })();

class WattsPipe {
    transform(watts, unit) {
        if (!watts) {
            return "";
        }
        watts = +watts;
        if (unit) {
            watts = watts * unit;
        }
        const kunit = 1000;
        const p = 1;
        if (watts >= Math.pow(kunit, 4)) {
            return (watts / Math.pow(kunit, 4)).toFixed(p) + 'TW';
        }
        if (watts >= 100 * Math.pow(kunit, 3)) {
            return (watts / Math.pow(kunit, 3)).toFixed(0) + 'GW';
        }
        if (watts >= 10 * Math.pow(kunit, 3)) {
            return (watts / Math.pow(kunit, 3)).toFixed(1) + 'GW';
        }
        if (watts >= Math.pow(kunit, 3)) {
            return (watts / Math.pow(kunit, 3)).toFixed(2) + 'GW';
        }
        if (watts >= 100 * Math.pow(kunit, 2)) {
            return (watts / Math.pow(kunit, 2)).toFixed(2) + 'MW';
        }
        if (watts >= 10 * Math.pow(kunit, 2)) {
            return (watts / Math.pow(kunit, 2)).toFixed(2) + 'MW';
        }
        if (watts >= Math.pow(kunit, 2)) {
            return (watts / Math.pow(kunit, 2)).toFixed(2) + 'MW';
        }
        if (watts >= 100 * kunit) {
            return (watts / kunit).toFixed(2) + 'kW';
        }
        if (watts >= 10 * kunit) {
            return (watts / kunit).toFixed(2) + 'kW';
        }
        if (watts >= kunit) {
            return (watts / kunit).toFixed(2) + 'kW';
        }
        return watts.toFixed(2) + 'W';
    }
}
WattsPipe.ɵfac = function WattsPipe_Factory(t) { return new (t || WattsPipe)(); };
WattsPipe.ɵpipe = ɵɵdefinePipe({ name: "watts", type: WattsPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WattsPipe, [{
        type: Pipe,
        args: [{ name: 'watts' }]
    }], null, null); })();

const fileTypeIconList = [
    { type: "xls", icon: "far fa-file-excel" },
    { type: "xlsx", icon: "far fa-file-excel" },
    { type: "csv", icon: "fas fa-file-csv" },
    { type: "pdf", icon: "far fa-file-pdf" },
    { type: "doc", icon: "far fa-file-word" },
    { type: "docx", icon: "far fa-file-word" },
    { type: "ppt", icon: "far fa-file-powerpoint" },
    { type: "pptx", icon: "far fa-file-powerpoint" },
    { type: "jpg", icon: "far fa-file-image" },
    { type: "jpeg", icon: "far fa-file-image" },
    { type: "tmc", icon: "far fa-file-video" }
];
class FileTypeIcoPipe {
    transform(file) {
        return this.getFileExtension(file);
    }
    getFileExtension(filename) {
        try {
            let ext = filename.split(".").pop();
            ext = ext.toLowerCase();
            let obj = fileTypeIconList.filter(row => {
                if (row.type === ext) {
                    return true;
                }
            });
            if (obj.length > 0) {
                let icon = obj[0].icon;
                return icon;
            }
            else {
                return "far fa-file";
            }
        }
        catch (err) {
            return "";
        }
    }
}
FileTypeIcoPipe.ɵfac = function FileTypeIcoPipe_Factory(t) { return new (t || FileTypeIcoPipe)(); };
FileTypeIcoPipe.ɵpipe = ɵɵdefinePipe({ name: "filetypeico", type: FileTypeIcoPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileTypeIcoPipe, [{
        type: Pipe,
        args: [{ name: 'filetypeico' }]
    }], null, null); })();

class SafeSanitizerPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafeSanitizerPipe.ɵfac = function SafeSanitizerPipe_Factory(t) { return new (t || SafeSanitizerPipe)(ɵɵdirectiveInject(DomSanitizer)); };
SafeSanitizerPipe.ɵpipe = ɵɵdefinePipe({ name: "safesanitizer", type: SafeSanitizerPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SafeSanitizerPipe, [{
        type: Pipe,
        args: [{
                name: 'safesanitizer'
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

class BaseUICommonModule {
}
BaseUICommonModule.ɵmod = ɵɵdefineNgModule({ type: BaseUICommonModule });
BaseUICommonModule.ɵinj = ɵɵdefineInjector({ factory: function BaseUICommonModule_Factory(t) { return new (t || BaseUICommonModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BaseUICommonModule, { declarations: [PDatePipe, ArraySortPipe, ListSortEntityPipe,
        SortIconPipe, NumberToPipe,
        FrVsiblePipe, FrFileDropDirective,
        FileUploadRatePipe, FileSizePipe, DurationPipe,
        WattsPipe,
        FileTypeIcoPipe,
        SafeSanitizerPipe], imports: [CommonModule], exports: [PDatePipe, ArraySortPipe, ListSortEntityPipe, SortIconPipe, NumberToPipe,
        FrVsiblePipe, FrFileDropDirective,
        FileUploadRatePipe, FileSizePipe, DurationPipe,
        WattsPipe,
        FileTypeIcoPipe,
        SafeSanitizerPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseUICommonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    PDatePipe, ArraySortPipe, ListSortEntityPipe,
                    SortIconPipe, NumberToPipe,
                    FrVsiblePipe, FrFileDropDirective,
                    FileUploadRatePipe, FileSizePipe, DurationPipe,
                    WattsPipe,
                    FileTypeIcoPipe,
                    SafeSanitizerPipe
                ],
                exports: [
                    PDatePipe, ArraySortPipe, ListSortEntityPipe, SortIconPipe, NumberToPipe,
                    FrVsiblePipe, FrFileDropDirective,
                    FileUploadRatePipe, FileSizePipe, DurationPipe,
                    WattsPipe,
                    FileTypeIcoPipe,
                    SafeSanitizerPipe
                ],
            }]
    }], null, null); })();

/*
 * Public API Surface of baseuicommon
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ArraySortPipe, BaseUICommonModule, DurationPipe, FileSizePipe, FileTypeIcoPipe, FileUploadRatePipe, FrFileDropDirective, FrVsiblePipe, ListSortEntityPipe, NumberToPipe, PDatePipe, SafeSanitizerPipe, SortIconPipe, WattsPipe };
//# sourceMappingURL=baseuicommon.js.map
